export default __webpack_public_path__ + "static/media/RELEVÉ-DE-CONNEXION-vierge-min.a5cc37c7.jpg";